import { IMaskInput } from 'react-imask';
import { useField } from 'formik';

export const MaskedField = ({ ...props }) => {
  const [field, , helpers] = useField(props.name);

  // quack like a Formik `Field`, but with masking!
  return (
    <IMaskInput
      {...field}
      {...props}
      onAccept={(value, _) => helpers.setValue(value)}
      onComplete={(value, _) => helpers.setValue(value)}
      unmask={false}
      // defining '9' for backcompat with existing masks
      definitions={{ 9: /\d/ }}
    />
  );
};
